import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  selectTenant,
  FeatureMap,
  isEnabledFn,
  isGroupEnabledFn,
} from 'state/tenant';

export type FeatureHook = () => {
  /**
   * A feature is enabled if it is configured in the tenant config
   */
  isEnabled: (feature: keyof FeatureMap) => boolean;

  /**
   * A group is enabled if any of its feature (defined in the GROUPING constant)
   * is enabled
   */
  isGroupEnabled: (group: Array<keyof FeatureMap>) => boolean;
};

const useFeature: FeatureHook = () => {
  const tenant = useSelector(selectTenant);

  const isEnabled = useCallback(
    (feature: keyof FeatureMap) => isEnabledFn(tenant, feature),
    [tenant],
  );

  const isGroupEnabled = useCallback(
    (group: Array<keyof FeatureMap>) => isGroupEnabledFn(tenant, group),
    [tenant],
  );

  return { isEnabled, isGroupEnabled };
};

export default useFeature;
